import { api } from "../configs/axiosConfig"

export const ReactionAPI = {
  sendReaction: async function (reaction, messageId, signal = false) {
    const conversationId = window.sessionStorage.getItem('conversationId');
    const password = window.localStorage.getItem('password');

    const response = await api.request({
      method: "POST",
      url: "/integration/api/reaction",
      auth: {
        username: "licowebapp",
        password: password
      },
      data: {
        conversationId: conversationId,
        messageId: messageId,
        reaction: reaction
      },
      signal: signal ? signal : undefined
    })

    return response.data
  },
}